import { useState, useEffect } from "react";
import HomePage from "./HomePage";
import contactPicture from "./pictures/gradienta-bKESVqfxass-unsplash.jpg";
//import contactPictureHomePage from "./pictures/pic14.jpg";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { firestore } from "./firebase";
import { functions } from "./firebase";
import Footer from "./Footer";
import CollectionNotice from "./components/CollectionNotice";
import { trackMetaEvent } from "./metaPixel";
function ContactPage({ OnContactPage = true }) {
  const [messageSent, setMessageSent] = useState(false);
  const [nameInput, setNameInput] = useState("");
  const [emailAddress, setEmailAddress] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [message, setMessage] = useState("");
  const [stylingOnClickContact, setstylingOnClickContact] = useState();
  useEffect(() => {
    let stop = false;
    if (stop) return;
    setstylingOnClickContact("MediumBlue");
    return () => (stop = true);
  }, []);
  const [subject, setSubject] = useState("Message from Contact Page");

  const handleMessage = async (e) => {
    setMessageSent(true);
    e.preventDefault();
    let todayDate = new Date().toString();
    if (emailAddress && nameInput && message) {
      var timeout;
      //clear previous timeout function if any
      clearTimeout(timeout);
      // database
      //   .ref("clientsMessages/")
      //   .push({
      //     username: nameInput,
      //     email: emailAddress,
      //     telephone: phoneNumber || "",
      //     callbackRequested: callbackRequested,
      //     tutorialRequest: tutorialRequest,

      //     message: message,
      //     Date: todayDate || "",
      //   })
      await addDoc(collection(firestore, "clientsMessages"), {
        username: nameInput,
        email: emailAddress,
        telephone: phoneNumber || "",
        callbackRequested: callbackRequested,
        tutorialRequest: tutorialRequest,
        message: message,
        Date: todayDate || "",
      }).then(async () => {
        //  functions.useEmulator("localhost", 5001);
        var EmailOnSupportRequestMessage = functions.httpsCallable(
          "EmailOnSupportRequestMessage"
        );

        await EmailOnSupportRequestMessage({
          id: nameInput + " " + emailAddress,

          emailSubject: `Message received - New message: ${
            subject || ""
          }. From: ${emailAddress}. Phone ${phoneNumber} Callback: ${callbackRequested} Tutorial: ${tutorialRequest} Date: ${todayDate}`,
          emailMessage:
            (message || "") +
            ` Message received - New message-Subject: ${
              subject || ""
            }. From: ${emailAddress}. Phone ${phoneNumber}`,
          emailHTML:
            ((message && message).replace(/\n/g, "<br />") || message || "") +
            `<br />Message received - New message-Subject: ${
              subject || ""
            }. From: ${emailAddress}. Phone ${phoneNumber}`,

          //can send data as an object
        })
          .then((result) => {
            // Read result of the Cloud Function.
            // var sanitizedMessage = result.data.text;
            // console.log(result.data);
            //  console.log("done");

            return result;
          })
          .catch((error) => {
            // Getting the Error details.
            var code = error.code;
            var message = error.message;
            var details = error.details;
            console.log(code, message, details);
            // ...
          });
      });

      trackMetaEvent("Lead", {
        content_name: tutorialRequest ? "Demo request" : "Contact request",
      });

      setNameInput("");
      setEmailAddress("");
      setPhoneNumber("");
      setCallBackRequested("");
      setTutorialRequested("");
      setMessage("");

      timeout = setTimeout(() => {
        setMessageSent(false);
      }, 1500);
    }
    //  var messageFromClient = functions.httpsCallable("messageFromClient");

    //  await messageFromClient({
    //    //  id: uid,
    //    username: nameInput,
    //    email: emailAddress,
    //    telephone: phoneNumber,
    //    message: message,
    //    //can send data as an object
    //  })
    //    .then((result) => {
    //      // Read result of the Cloud Function.
    //      // var sanitizedMessage = result.data.text;
    //      // console.log(result.data);

    //      return result;
    //    })
    //    .catch((error) => {
    //      // Getting the Error details.
    //      var code = error.code;
    //      var message = error.message;
    //      var details = error.details;
    //      // ...
    //    });
  };
  const [callbackRequested, setCallBackRequested] = useState(false);
  const handleChange = (e) => {
    setNameInput(e.target.value);
  };
  const handleChange1 = (e) => {
    setEmailAddress(e.target.value);
  };
  const handleChange2 = (e) => {
    setPhoneNumber(e.target.value);
  };

  const handleChange3 = (e) => {
    setMessage(e.target.value);
  };
  const handleChange4 = (e) => {
    setCallBackRequested(e.target.checked);
  };
  const [tutorialRequest, setTutorialRequested] = useState(false);

  const handleChange5 = (e) => {
    setTutorialRequested(e.target.checked);
  };
  const [subscribeInfo, setsubscribeInfo] = useState("");
  const [marketingConsent, setMarketingConsent] = useState(false);
  const handleSubscribeEmail = (e) => {
    setsubscribeInfo(e.target.value);
  };
  const [subscribeAlert, setSubscribeAlert] = useState(false);
  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (subscribeInfo && marketingConsent) {
      var timeout1;
      // record
      clearTimeout(timeout1);
      await addDoc(collection(firestore, "subscribers"), {
        email: subscribeInfo,
        status: "active",
        subscribedAt: serverTimestamp(),
        marketingConsent: true,
        consentScope: "CircleGrid updates, new features and promotions",
        consentMethod: "contact_page_checkbox",
        consentRecordedAt: serverTimestamp(),
        privacyNoticeVersion: "2026-08-09",
        sourcePage: window.location.pathname,
      });
      trackMetaEvent("Subscribe", { content_name: "CircleGrid updates" });
      setsubscribeInfo("");
      setMarketingConsent(false);
      setSubscribeAlert(true);
      timeout1 = setTimeout(() => {
        setSubscribeAlert(false);
      }, 1500);
    }
  };

  return (
    <div className="contact-page" style={{ width: "100%", textAlign: "left" }}>
      {OnContactPage && (
        <HomePage stylingOnClickContact={stylingOnClickContact} />
      )}
      {OnContactPage && (
        <div
          style={{
            background:
              "linear-gradient(135deg, #10b981 0%, #059669 50%, #047857 100%)",
            minHeight: "400px",
            display: "flex",
            alignItems: "center",
            position: "relative",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              position: "absolute",
              inset: 0,
              backgroundImage: `url(${contactPicture})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              opacity: 0.2,
            }}
          />
          <div
            style={{
              maxWidth: "1200px",
              margin: "0 auto",
              padding: "60px 20px",
              position: "relative",
              zIndex: 2,
            }}
          >
            <div
              style={{
                background: "rgba(255, 255, 255, 0.95)",
                borderRadius: "16px",
                padding: "40px",
                boxShadow: "0 20px 40px rgba(0, 0, 0, 0.1)",
                backdropFilter: "blur(10px)",
              }}
            >
              <h1
                style={{
                  color: "#047857",
                  fontSize: "3rem",
                  fontWeight: "800",
                  marginBottom: "24px",
                  textAlign: "center",
                }}
              >
                Get in Touch
              </h1>
              <p
                style={{
                  color: "#6b7280",
                  fontSize: "1.2rem",
                  textAlign: "center",
                  marginBottom: "32px",
                  lineHeight: "1.6",
                }}
              >
                We'd love to hear from you. Send us a message and we'll respond
                as soon as possible.
              </p>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
                  gap: "24px",
                }}
              >
                <div
                  style={{
                    background: "#f8fafc",
                    padding: "24px",
                    borderRadius: "12px",
                    textAlign: "left",
                  }}
                >
                  <div
                    style={{
                      background: "#10b981",
                      color: "white",
                      width: "56px",
                      height: "56px",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0 auto 16px",
                      fontSize: "24px",
                    }}
                  >
                    ✉️
                  </div>
                  <h3
                    style={{
                      color: "#047857",
                      fontSize: "1.25rem",
                      fontWeight: "600",
                      marginBottom: "8px",
                    }}
                  >
                    Email Us
                  </h3>
                  <a
                    href="mailto:info@circlegrid.org"
                    style={{
                      color: "#10b981",
                      textDecoration: "none",
                      fontSize: "1.1rem",
                      fontWeight: "500",
                    }}
                  >
                    info@circlegrid.org
                  </a>
                </div>
                <div
                  style={{
                    background: "#f8fafc",
                    padding: "24px",
                    borderRadius: "12px",
                    textAlign: "left",
                  }}
                >
                  <div
                    style={{
                      background: "#10b981",
                      color: "white",
                      width: "56px",
                      height: "56px",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0 auto 16px",
                      fontSize: "24px",
                    }}
                  >
                    📞
                  </div>
                  <h3
                    style={{
                      color: "#047857",
                      fontSize: "1.25rem",
                      fontWeight: "600",
                      marginBottom: "8px",
                    }}
                  >
                    Call Us
                  </h3>
                  <a
                    href="tel:27631401165"
                    style={{
                      color: "#10b981",
                      textDecoration: "none",
                      fontSize: "1.1rem",
                      fontWeight: "500",
                    }}
                  >
                    +27 63 140 1165
                  </a>
                  <p
                    style={{
                      color: "#6b7280",
                      fontSize: "0.9rem",
                      margin: "4px 0 0 0",
                    }}
                  >
                    9 AM - 5 PM SAST
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* {!OnContactPage && (
        <div
          style={{
            backgroundImage: `url(${contactPictureHomePage})`,
            height: 300,
            marginBottom: 25,
            width: "100%",
            backgroundSize: "200%",
          }}
        >
      
          <h1
            style={{
              //color: "blue ",
              textAlign: "center",
              padding: 10,
              paddingTop: 100,

              fontFamily: "calibri",
            }}
          >
            Schedule a free demo session.
          </h1>
        </div>
      )} */}
      {
        <div
          style={{
            background: "#f8fafc",
            padding: "80px 0",
          }}
        >
          <div
            style={{
              maxWidth: "800px",
              margin: "0 auto",
              padding: "0 20px",
            }}
          >
            <div
              style={{
                background: "white",
                borderRadius: "16px",
                padding: "48px",
                boxShadow: "0 20px 40px rgba(0, 0, 0, 0.08)",
              }}
            >
              <h2
                style={{
                  color: "#047857",
                  fontSize: "2.5rem",
                  fontWeight: "700",
                  textAlign: "center",
                  marginBottom: "48px",
                }}
              >
                Send us a Message
              </h2>
              <form
                onSubmit={handleMessage}
                style={{
                  display: "grid",
                  gap: "24px",
                }}
              >
                <div style={{ display: "grid", gap: "8px" }}>
                  <label
                    style={{
                      color: "#374151",
                      fontWeight: "600",
                      fontSize: "1rem",
                    }}
                  >
                    Full Name *
                  </label>
                  <input
                    placeholder="Enter your full name"
                    required
                    type="text"
                    value={nameInput}
                    onChange={handleChange}
                    style={{
                      padding: "16px",
                      border: "2px solid #e5e7eb",
                      borderRadius: "12px",
                      fontSize: "1rem",
                      transition: "all 0.3s ease",
                      outline: "none",
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = "#10b981";
                      e.target.style.boxShadow =
                        "0 0 0 3px rgba(16, 185, 129, 0.1)";
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = "#e5e7eb";
                      e.target.style.boxShadow = "none";
                    }}
                  />
                </div>

                <div style={{ display: "grid", gap: "8px" }}>
                  <label
                    style={{
                      color: "#374151",
                      fontWeight: "600",
                      fontSize: "1rem",
                    }}
                  >
                    Email Address *
                  </label>
                  <input
                    required
                    placeholder="Enter your email address"
                    type="email"
                    value={emailAddress}
                    onChange={handleChange1}
                    style={{
                      padding: "16px",
                      border: "2px solid #e5e7eb",
                      borderRadius: "12px",
                      fontSize: "1rem",
                      transition: "all 0.3s ease",
                      outline: "none",
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = "#10b981";
                      e.target.style.boxShadow =
                        "0 0 0 3px rgba(16, 185, 129, 0.1)";
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = "#e5e7eb";
                      e.target.style.boxShadow = "none";
                    }}
                  />
                </div>

                <div style={{ display: "grid", gap: "8px" }}>
                  <label
                    style={{
                      color: "#374151",
                      fontWeight: "600",
                      fontSize: "1rem",
                    }}
                  >
                    Phone Number (Optional)
                  </label>
                  <input
                    placeholder="Enter your phone number"
                    type="tel"
                    value={phoneNumber}
                    onChange={handleChange2}
                    style={{
                      padding: "16px",
                      border: "2px solid #e5e7eb",
                      borderRadius: "12px",
                      fontSize: "1rem",
                      transition: "all 0.3s ease",
                      outline: "none",
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = "#10b981";
                      e.target.style.boxShadow =
                        "0 0 0 3px rgba(16, 185, 129, 0.1)";
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = "#e5e7eb";
                      e.target.style.boxShadow = "none";
                    }}
                  />
                </div>

                <div style={{ display: "grid", gap: "8px" }}>
                  <label
                    style={{
                      color: "#374151",
                      fontWeight: "600",
                      fontSize: "1rem",
                    }}
                  >
                    Message *
                  </label>
                  <textarea
                    value={message}
                    onChange={handleChange3}
                    placeholder="Tell us how we can help you..."
                    rows="6"
                    style={{
                      padding: "16px",
                      border: "2px solid #e5e7eb",
                      borderRadius: "12px",
                      fontSize: "1rem",
                      transition: "all 0.3s ease",
                      outline: "none",
                      resize: "vertical",
                      fontFamily: "inherit",
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = "#10b981";
                      e.target.style.boxShadow =
                        "0 0 0 3px rgba(16, 185, 129, 0.1)";
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = "#e5e7eb";
                      e.target.style.boxShadow = "none";
                    }}
                  />
                </div>

                <div style={{ display: "grid", gap: "16px" }}>
                  <label
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                      color: "#374151",
                      fontWeight: "500",
                      cursor: "pointer",
                    }}
                  >
                    <input
                      type="checkbox"
                      onChange={handleChange4}
                      style={{
                        width: "18px",
                        height: "18px",
                        accentColor: "#10b981",
                      }}
                    />
                    Request a call back
                  </label>

                  <label
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                      color: "#374151",
                      fontWeight: "500",
                      cursor: "pointer",
                    }}
                  >
                    <input
                      type="checkbox"
                      onChange={handleChange5}
                      style={{
                        width: "18px",
                        height: "18px",
                        accentColor: "#10b981",
                      }}
                    />
                    Request a free online demo session
                  </label>
                </div>

                {tutorialRequest && (
                  <div
                    style={{
                      marginTop: "24px",
                      border: "2px solid #e5e7eb",
                      borderRadius: "12px",
                      overflow: "hidden",
                    }}
                  >
                    <iframe
                      title="Booking"
                      src="https://calendar.google.com/calendar/appointments/schedules/AcZssZ392VYq1sQIs5C5auyiGnvyShLYZMY2dB1QNX2XwDzSjFM1jixkdLxQ5ISv8CVnbl4u4V3KQEv9?gv=true"
                      style={{ border: 0, width: "100%" }}
                      width="100%"
                      height="600"
                      frameBorder="0"
                    />
                  </div>
                )}

                <CollectionNotice>
                  We&apos;ll use these details to reply and arrange any callback or
                  demo you request.
                </CollectionNotice>

                <button
                  type="submit"
                  style={{
                    background: messageSent
                      ? "linear-gradient(135deg, #059669 0%, #047857 100%)"
                      : "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                    color: "white",
                    border: "none",
                    padding: "16px 32px",
                    borderRadius: "12px",
                    fontSize: "1.1rem",
                    fontWeight: "600",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    marginTop: "16px",
                    boxShadow: "0 4px 12px rgba(16, 185, 129, 0.3)",
                  }}
                  onMouseEnter={(e) => {
                    if (!messageSent) {
                      e.target.style.transform = "translateY(-2px)";
                      e.target.style.boxShadow =
                        "0 8px 25px rgba(16, 185, 129, 0.4)";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!messageSent) {
                      e.target.style.transform = "translateY(0)";
                      e.target.style.boxShadow =
                        "0 4px 12px rgba(16, 185, 129, 0.3)";
                    }
                  }}
                >
                  {messageSent ? "✓ Message Sent!" : "Send Message"}
                </button>
              </form>
            </div>
          </div>
        </div>
      }
      <div
        style={{
          background:
            "linear-gradient(135deg, #10b981 0%, #059669 50%, #047857 100%)",
          padding: "80px 0",
          position: "relative",
        }}
      >
        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
            padding: "0 20px",
          }}
        >
          <div
            style={{
              background: "white",
              borderRadius: "20px",
              padding: "48px",
              boxShadow: "0 25px 50px rgba(0, 0, 0, 0.15)",
              textAlign: "center",
            }}
          >
            <div
              style={{
                background: "#10b981",
                color: "white",
                width: "80px",
                height: "80px",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 24px",
                fontSize: "36px",
              }}
            >
              📧
            </div>

            <h2
              style={{
                color: "#047857",
                fontSize: "2.5rem",
                fontWeight: "700",
                marginBottom: "16px",
              }}
            >
              Stay Updated
            </h2>

            <p
              style={{
                color: "#6b7280",
                fontSize: "1.2rem",
                marginBottom: "40px",
                lineHeight: "1.6",
              }}
            >
              Subscribe for CircleGrid updates, new features, and exclusive
              promotions
            </p>

            <div
              style={{
                display: "flex",
                gap: "16px",
                maxWidth: "500px",
                margin: "0 auto",
                alignItems: "center",
                flexWrap: "wrap",
                justifyContent: "center",
              }}
            >
              <input
                type="email"
                placeholder="Enter your email address"
                value={subscribeInfo}
                onChange={handleSubscribeEmail}
                style={{
                  flex: "1",
                  minWidth: "250px",
                  padding: "16px 20px",
                  border: "2px solid #e5e7eb",
                  borderRadius: "12px",
                  fontSize: "1rem",
                  outline: "none",
                  transition: "all 0.3s ease",
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = "#10b981";
                  e.target.style.boxShadow =
                    "0 0 0 3px rgba(16, 185, 129, 0.1)";
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = "#e5e7eb";
                  e.target.style.boxShadow = "none";
                }}
              />

              <button
                onClick={handleSubscribe}
                disabled={!subscribeInfo || !marketingConsent}
                style={{
                  background:
                    "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                  color: "white",
                  border: "none",
                  padding: "16px 32px",
                  borderRadius: "12px",
                  fontSize: "1rem",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  boxShadow: "0 4px 12px rgba(16, 185, 129, 0.3)",
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = "translateY(-2px)";
                  e.target.style.boxShadow =
                    "0 8px 25px rgba(16, 185, 129, 0.4)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = "translateY(0)";
                  e.target.style.boxShadow =
                    "0 4px 12px rgba(16, 185, 129, 0.3)";
                }}
              >
                Subscribe
              </button>
            </div>

            <label
              style={{
                display: "flex",
                gap: 10,
                alignItems: "flex-start",
                maxWidth: 500,
                margin: "18px auto 0",
                textAlign: "left",
                color: "#374151",
              }}
            >
              <input
                type="checkbox"
                checked={marketingConsent}
                onChange={(e) => setMarketingConsent(e.target.checked)}
              />
              <span>
                I consent to promotional emails from CircleGrid about updates,
                new features and promotions. I can unsubscribe at any time.
              </span>
            </label>
            {subscribeAlert && (
              <div
                style={{
                  marginTop: "24px",
                  padding: "16px 24px",
                  background: "#d1fae5",
                  color: "#047857",
                  borderRadius: "12px",
                  fontWeight: "600",
                  fontSize: "1.1rem",
                }}
              >
                ✓ Thanks for subscribing! We'll keep you updated.
              </div>
            )}
          </div>
        </div>
      </div>

      {OnContactPage && <Footer />}
    </div>
  );
}

export default ContactPage;
